import { React, useContext, useEffect, useState } from 'react'

import { Dropdown, Modal, Offcanvas } from 'react-bootstrap';

import Form from 'react-bootstrap/Form';

import { useAuth } from 'react-oidc-context';

import TransparentButton from '../../utils/TransparentButton';

import { Button } from '@mui/material';

import { SnackbarContext } from '../../App';

import TransparentButtonDark from '../../utils/TransparentButtonDark';

export default ({ show, onClose, onConfirm }) => {

    const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

    const auth = useAuth();

    const [sites, setSites] = useState([]);

    const [selectedSite, setSelectedSite] = useState(null);

    const [currentSiteName, setCurrentSiteName] = useState(null);

    const [hasConfiguredSite, setHasConfiguredSite] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {

        if (show) {

            fetchSharePointData();

        }

    }, [show]);

    function findMatchingSite(sitesList, savedSiteName) {

        if (!savedSiteName) return null;

        return sitesList.find((site) =>
            site.graphSitePath === savedSiteName ||
            site.webUrl === savedSiteName ||
            site.name === savedSiteName ||
            site.displayName === savedSiteName
        ) || null;

    }

    function fetchSharePointData() {

        setIsLoading(true);

        Promise.all([
            fetch(`${window.origin}/api/dochero/available-sharepoint-sites`, {

                method: "GET",

                headers: {

                    "Content-Type": "application/json",

                    "Authorization": `Bearer ${auth.user?.access_token}`

                },

            }),

            fetch(`${window.origin}/api/dochero/current-site`, {

                method: "GET",

                headers: {

                    "Content-Type": "application/json",

                    "Authorization": `Bearer ${auth.user?.access_token}`

                },

            })
        ])

            .then(async ([sitesResponse, currentSiteResponse]) => {

                if (sitesResponse.status === 403 || currentSiteResponse.status === 403) {

                    setSessionExpired(true);

                    throw new Error('Session expired');

                }

                if (!sitesResponse.ok) {

                    throw new Error('Failed to fetch SharePoint sites');

                }

                if (!currentSiteResponse.ok) {

                    throw new Error('Failed to fetch current SharePoint site');

                }

                const sitesData = await sitesResponse.json();

                const currentSiteData = await currentSiteResponse.json();

                return {
                    sites: sitesData.sites || [],
                    currentSite: currentSiteData.currentSite || null,
                };

            })

            .then(({ sites, currentSite }) => {

                const savedSiteName = currentSite?.site_name || null;

                setSites(sites);

                setCurrentSiteName(savedSiteName);

                setHasConfiguredSite(!!savedSiteName);

                const matchedSite = findMatchingSite(sites, savedSiteName);

                setSelectedSite(matchedSite);

            })

            .catch((error) => {

                console.error('Failed to fetch SharePoint data:', error);

                setSnackBarMessage('Failed to load SharePoint sites. Please try again later');

                setSnackBarShow(true);

            })

            .finally(() => {

                setIsLoading(false);

            });

    }

    function confirmHandler() {

        if (hasConfiguredSite) {

            setSnackBarMessage('A SharePoint site has been configured. Please contact support to change SharePoint site.');

            setSnackBarShow(true);

            return;

        }

        if (!selectedSite) {

            setSnackBarMessage('Please select a SharePoint site');

            setSnackBarShow(true);

            return;

        }

        if (onConfirm) {

            onConfirm(selectedSite);

        }

        onClose();

        setSnackBarMessage('SharePoint site selected');

        setSnackBarShow(true);

    }

    function closeHandler() {

        onClose();

        setTimeout(() => {

            setSites([]);

            setSelectedSite(null);

            setCurrentSiteName(null);

            setHasConfiguredSite(false);

            setIsLoading(false);

        }, 200);

    }

    return (

        <>

            <Modal

                show={show}

                onHide={closeHandler}

                dialogClassName="modal-50w"

                aria-labelledby="example-custom-modal-styling-title"

            >

                <Modal.Body style={{ padding: '2vw 3vw', paddingBottom: '0vw', textAlign: 'center', color: 'rgb(0, 0, 0, 0.8)' }}>

                    <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '2vw', fontWeight: '500' }}>Select SharePoint site</h4>

                    <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw' }}>

                        Please select the SharePoint site you want to connect.

                    </p>

                    <Form.Group style={{ marginBottom: '1.5vw', flex: 1, textAlign: 'left' }}>

                        {hasConfiguredSite && (

                            <p style={{

                                margin: 0,

                                marginBottom: '1vw',

                                fontWeight: '300',

                                fontSize: '0.8vw',

                                color: '#1c6c6c',

                                backgroundColor: 'rgba(28, 108, 108, 0.08)',

                                borderRadius: '0.5vw',

                                padding: '0.8vw 1vw',

                                textAlign: 'center'

                            }}>

                                A SharePoint site has been configured. Please contact support to change SharePoint site.

                            </p>

                        )}

                        <p style={{ fontSize: '0.85vw' }}>Available SharePoint Sites</p>

                        <div

                            style={{

                                maxHeight: '18vw',

                                overflowY: 'auto',

                                backgroundColor: 'rgba(255,255,255,.4)',

                                border: 'none',

                                borderRadius: '0.5vw',

                                padding: '0.5vw',

                            }}

                        >

                            {isLoading && (

                                <div style={{ textAlign: 'center', padding: '3vw 0' }}>

                                    <div className="spinner-border" role="status">

                                        <span className="visually-hidden">Loading...</span>

                                    </div>

                                </div>

                            )}

                            {!isLoading && sites.length === 0 && (

                                <p style={{ margin: 0, fontSize: '0.8vw', fontWeight: '300', textAlign: 'center', padding: '2vw 0' }}>

                                    No SharePoint sites available.

                                </p>

                            )}

                            {!isLoading && sites.map((site, index) => {

                                const isSelected = selectedSite?.id === site.id;

                                return (

                                    <div

                                        key={site.id || index}

                                        onClick={() => {

                                            if (!hasConfiguredSite) {

                                                setSelectedSite(site);

                                            }

                                        }}

                                        style={{

                                            cursor: hasConfiguredSite ? 'not-allowed' : 'pointer',

                                            padding: '0.8vw 1vw',

                                            borderRadius: '0.5vw',

                                            marginBottom: '0.5vw',

                                            backgroundColor: isSelected ? '#1c6c6c' : 'rgba(255,255,255,.45)',

                                            border: isSelected ? '1px solid #1c6c6c' : '1px solid rgba(255,255,255,0)',

                                        }}

                                    >

                                        <p style={{

                                            margin: 0,

                                            fontSize: '0.85vw',

                                            fontWeight: isSelected ? '500' : '400',

                                            color: isSelected ? 'white' : 'rgb(0, 0, 0, 0.85)'

                                        }}>

                                            {site.displayName || site.name}

                                        </p>

                                    </div>

                                );

                            })}

                        </div>

                        <Button

                            onClick={confirmHandler}

                            disabled={hasConfiguredSite}

                            variant="outlined"

                            style={{

                                borderColor: 'rgb(255, 255, 255, 1)',

                                color: hasConfiguredSite ? 'rgba(255, 255, 255, 0.55)' : 'rgb(255, 255, 255, 0.9)',

                                padding: '0.7vw',

                                marginBottom: '1.5vw',

                                border: 'none',

                                backgroundImage: hasConfiguredSite

                                    ? 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#8a8a8a, #8a8a8a)'

                                    : 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)',

                                borderRadius: '0.5vw',

                                textTransform: 'none',

                                fontSize: '1vw',

                                fontWeight: 500,

                                letterSpacing: '0.08vw',

                                width: '100%',

                                marginTop: '2.5vw'

                            }}

                        >

                            Confirm

                        </Button>

                    </Form.Group>

                </Modal.Body>

            </Modal>

        </>

    )

}